// Hook szczegółów własnej oferty - GET /sales-crm/my-offers/:id

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmMyOffer {
  id: number;
  number: string | null;
  status: number | null;
  statusFormatted: string | null;
  actualVersionId: number | null;
  validUntil: string | null;
  valueNet: number;
  valueGross: number;
  createdAt: string | null;
  updatedAt: string | null;
  /**
   * ID koszyka utworzonego z tej oferty po jej akceptacji przez klienta.
   * `null` jeśli oferta jeszcze nie została zaakceptowana lub backend nie utworzył koszyka.
   */
  cartId: number | null;
  /**
   * ID zamowienia zlozonego z koszyka utworzonego z tej oferty.
   * `null` gdy klient jeszcze nie zatwierdzil koszyka (ConfirmCartService).
   */
  orderId: number | null;
  orderNumber: string | null;
  /**
   * Flaga okresowości oferty - klient może wielokrotnie zrealizować ofertę
   * (POST /fulfill) w okresie ważności.
   */
  isPeriodic: boolean;
}

export const getSalesCrmMyOfferQueryKey = (offerId: string | number) =>
  ['sales-crm', 'my-offer', String(offerId)] as const;

const getSalesCrmMyOffer = (offerId: string | number): Promise<ISalesCrmMyOffer> =>
  axios.get(`/sales-crm/my-offers/${offerId}`);

export const useGetSalesCrmMyOffer = (
  offerId: string | number,
  options?: UseQueryOptions<ISalesCrmMyOffer, IError>
) =>
  useQuery<ISalesCrmMyOffer, IError>(
    getSalesCrmMyOfferQueryKey(offerId),
    () => getSalesCrmMyOffer(offerId),
    {
      ...options,
      enabled: options?.enabled !== false && String(offerId).trim().length > 0
    }
  );
